export default {
  title1: 'All-in-One platform for International School',
  basics: 'Basic Module',
  title2: 'Management',
  admission: 'Admissions',
  curriculum: 'Curriculum',
  moments: 'Moments',
  livestream: 'Livestream',
  adm_discrb: 'Manage enrollment applications, campus visits, student information and track progress easily in one system.',
  curc_discrb: 'Based on CGC framework, help teachers to plan courses from four parts (Define, Design,Delivery, Evaluation), and the curriculum can be shared and collaborated',
  moms_discrb: 'Record and share students’ activities and growth with parents through multiple tools (photos, videos, files, texts, chats).',
  lvs_disscrb: 'Live courses, sport activities, celebration and so on, so that parents can watch online at any time.',
  basics_discrb: 'Manage data, settings, authorization all in one place and apply to all.'
}



// WEBPACK FOOTER //
// ./src/views/home/lang/en.js